import React, { useContext, useEffect, useRef } from 'react';
import Pages from '../../../../../config/Pages';
import { inputsSerieHistorica } from '../../PageInputs';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import SimpleTable from '../../../../../core/components/simpleTables/SimpleTable';
import { Column } from 'primereact/column';
import styles from './FormSerieHistorica.module.scss';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import FormTopo from './FormTopo';
import { InputText } from 'primereact/inputtext';
import { arrayToDateString, dateToString } from '../../../../../core/utils/DateMixins';
import ButtonSeplag from '../../../../../components/buttonSeplag/ButtonSeplag';
import Buttons from '../Buttons';
import FieldWithInfo from '../FieldWithInfo';
import { isEmpty } from '../../../../../core/utils/ValidForm';
import { MultipageContext } from '../../../../../core/components/Multipage';
import propostaIndicadorService from '../../../../../service/PropostaIndicadorService';
import historicoService from '../../../../../service/HistoricoService';
import { printToast } from '../../../../../core/utils/Global';
import Shareds from '../../../../../config/translations/Shareds';
import { errosTratados } from '../../../../../config/Axios';
import PageMessages from '../../../../../config/translations/PageMessages';
import indicadorService from '../../../../../service/IndicadorService';
import stylesDiff from '../Utils.module.scss';

function FormSerieHistorica({
    isView,
    onEnviar,
    disableButtonVoltar,
    onFind,
    disableButtonEnviar = false,
}) {
    const {
        idProposta,
        confirmRef,
        multipageRef,
        confirmOkRef,
        nmIndicador,
        voltarUrl,
        idIndicador,
    } = useContext(MultipageContext);
    const formRef = useRef(null);
    const formTopo = useRef(null);
    const tableRef = useRef(null);
    const dadosIndicadorRef = useRef(null);

    useEffect(() => {
        if (!isEmpty(idProposta)) {
            formRef.current?.onLoad();
        }
    }, []);

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit} className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            {!isView && (
                <>
                    <FieldWithInfo
                        formController={formController}
                        formik={formik}
                        id="dataReferencia"
                        cols="12 3"
                    >
                        <Calendar
                            value={formik.values.dataReferencia}
                            onChange={formik.handleChange}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            locale="ptBr"
                        />
                    </FieldWithInfo>
                    <FieldWithInfo
                        formController={formController}
                        formik={formik}
                        id="dataApuracao"
                        cols="12 3"
                    >
                        <Calendar
                            value={formik.values.dataApuracao}
                            onChange={formik.handleChange}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            locale="ptBr"
                        />
                    </FieldWithInfo>
                    <FieldWithInfo
                        formController={formController}
                        formik={formik}
                        id="valorApurado"
                        cols="12 4"
                    >
                        <InputText
                            value={formik.values.valorApurado}
                            onChange={formik.handleChange}
                        />
                    </FieldWithInfo>
                    <div className={styles.containerButton}>
                        <Button
                            icon="pi pi-arrow-circle-down"
                            type="submit"
                            label="Incluir"
                            onClick={() => formController.addCountClick()}
                        />
                    </div>
                </>
            )}
        </form>
    );
    return (
        <>
            <FormTopo
                ref={formTopo}
                idIndicador={idIndicador}
                dadosIndicadorRef={dadosIndicadorRef}
                isView={isView}
            />
            <div className={styles.container}>
                <BaseForm
                    ref={formRef}
                    page={Pages.sei.propostaIndicador}
                    initialValues={inputsSerieHistorica.filter(
                        (input) => input?.form?.use ?? false
                    )}
                    prepareInitialValues={async ({
                        concordaTermo,
                        tipoCadastroProposta,
                        historicoPropostas,
                        historicoIndicadores,
                        ...rest
                    }) => {
                        formTopo.current?.setInitialValues({
                            concordaTermo: concordaTermo ?? false,
                            tipoCadastroProposta,
                        });
                        const historico = Array.isArray(historicoIndicadores)
                            ? historicoIndicadores
                            : historicoPropostas;
                        if (Array.isArray(historico)) {
                            tableRef.current?.setLista(
                                historico.map(({ dataApuracao, dataReferencia, ...rest }) => ({
                                    ...rest,
                                    dataApuracao: arrayToDateString(dataApuracao),
                                    dataReferencia: arrayToDateString(dataReferencia),
                                })),
                                true
                            );
                        }

                        return rest;
                    }}
                    onBuscar={async (form) => {
                        const response = await onFind(idProposta);

                        const dadosTratados = await propostaIndicadorService
                            .getMapper()
                            .formatToInput(response, form);

                        if (idIndicador) {
                            const responseIndicador = await indicadorService.getSerieHistorica(
                                idIndicador
                            );
                            const dados = await propostaIndicadorService
                                .getMapper()
                                .formatToInput(responseIndicador, form);
                            dadosIndicadorRef.current = dados;
                        }

                        return dadosTratados;
                    }}
                    buscarOnLoad={false}
                    onSubmit={async ({ registro, formController }) => {
                        const { dataApuracao, dataReferencia, valorApurado } = registro;
                        tableRef.current?.setLista([
                            {
                                valorApurado,
                                dataReferencia: dateToString(dataReferencia),
                                dataApuracao: dateToString(dataApuracao),
                                localId: `${valorApurado}-${dateToString(
                                    dataReferencia
                                )}-${dateToString(dataApuracao)}`,
                            },
                            ...(tableRef.current?.lista ?? []),
                        ]);
                        formController.setCountClick(0);
                        formRef.current?.formik.setValues(formController.initialValues);
                    }}
                    redirectOnSave={false}
                    showToast={false}
                >
                    <Inputs />
                </BaseForm>
                <SimpleTable
                    ref={tableRef}
                    paginator={false}
                    rowClassName={({ localId, ...dados }) => {
                        const ids = dadosIndicadorRef?.current?.historicoIndicadores.map(
                            ({ dataApuracao, dataReferencia, valorApurado }) =>
                                `${valorApurado}-${arrayToDateString(
                                    dataReferencia
                                )}-${arrayToDateString(dataApuracao)}`
                        );
                        if (isEmpty(localId) && idIndicador) {
                            const id = `${dados?.valorApurado}-${dados?.dataReferencia}-${dados?.dataApuracao}`;
                            return !ids.includes(id) ? stylesDiff.tableDiff : '';
                        }
                        return !isEmpty(localId) && idIndicador ? stylesDiff.tableDiff : '';
                    }}
                >
                    {inputsSerieHistorica.map((input, index) => (
                        <Column key={index} field={input?.name} header={input?.label} />
                    ))}
                    {!isView && (
                        <Column
                            header="Excluir"
                            style={{ width: '50px' }}
                            body={(data) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <ButtonSeplag
                                        tipo="danger"
                                        type="button"
                                        tooltip="Excluir"
                                        tooltipOptions={{ position: 'top' }}
                                        icon="pi pi-trash"
                                        className="p-button-danger p-mb-1"
                                        onClick={async () => {
                                            if (data?.id) {
                                                await historicoService.remover(data);

                                                printToast({
                                                    severity: 'success',
                                                    summary: 'Históricos',
                                                    detail: Shareds.form.successDelete,
                                                });
                                                tableRef.current?.setLista(
                                                    tableRef.current?.lista.filter(
                                                        ({ id }) => `${id}` !== `${data?.id}`
                                                    ),
                                                    true
                                                );
                                            } else {
                                                tableRef.current?.setLista(
                                                    tableRef.current?.lista.filter(
                                                        ({ localId }) =>
                                                            `${localId}` !== `${data?.localId}`
                                                    )
                                                );
                                            }
                                        }}
                                        theme="Raised"
                                    />
                                </div>
                            )}
                        />
                    )}
                </SimpleTable>
            </div>
            <Buttons
                showEnviarButton
                isView={isView}
                disableButtonVoltar={disableButtonVoltar}
                disableButtonEnviar={disableButtonEnviar}
                onVoltar={() => {
                    const voltar = () =>
                        multipageRef?.current?.tab?.last !== null
                            ? multipageRef?.current?.alterTab(multipageRef?.current?.tab?.last)
                            : history.push(`${voltarUrl}`);

                    let hasDiffTable =
                        tableRef.current?.initialTableData.length !==
                            tableRef.current?.lista.length ||
                        tableRef.current?.lista.filter((el) => isEmpty(el?.id)).length > 0;

                    if (formTopo.current.verificaAlteracao() || hasDiffTable) {
                        confirmRef.current?.show(Shareds.form.dontSaveData, () =>
                            setTimeout(() => voltar(), 500)
                        );
                    } else {
                        voltar();
                    }
                }}
                onSalvar={async () => {
                    try {
                        if (
                            formTopo.current?.formik?.values?.tipoCadastroProposta
                                ?.codgTipoCadProposta === 'NOVO' &&
                            formTopo.current?.formik?.values?.concordaTermo !== true
                        ) {
                            confirmOkRef.current?.show(
                                PageMessages.sei.propostaIndicador.termosObrigatorios
                            );
                            return;
                        }
                        await propostaIndicadorService.saveSerieHistorica(idProposta, {
                            ...formTopo.current?.formik.values,
                            historicoPropostas: tableRef.current.lista,
                        });
                        printToast({
                            severity: 'success',
                            summary: 'Históricos',
                            detail: Shareds.form.successUpdate,
                        });
                        formTopo.current?.formController.setCountClick(0);
                        formRef.current?.onLoad();
                    } catch (error) {
                        if (Array.isArray(error?.response?.data?.errors)) {
                            error?.response?.data?.errors.forEach((error) => {
                                formTopo.current?.formik.setFieldError(error.field, error.message);
                            });
                        }
                    }
                }}
                onEnviar={async () => {
                    try {
                        const response = await propostaIndicadorService.enviarAnaliseNegocial(
                            idProposta
                        );
                        printToast({
                            severity: 'success',
                            summary: 'Série Histórica',
                            detail: PageMessages.sei.propostaIndicador.enviarParaAnaliseNegocial
                                .replace('{NUMERO}', idProposta)
                                .replace('{NOME}', nmIndicador),
                        });
                        if (onEnviar) {
                            onEnviar(response);
                        }
                    } catch (error) {
                        if (error?.response && !errosTratados.includes(error.response.status)) {
                            printToast({
                                severity: 'error',
                                summary: 'Série Histórica',
                                detail: error.response,
                            });
                        }
                    }
                }}
            />
        </>
    );
}

export default FormSerieHistorica;
